export const DASFooter = () => {
  return (
    <footer className="bg-black text-white py-8 md:py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-6 md:mb-8">
          <div>
            <h3 className="font-heading font-bold text-lg mb-4">DAS Group AG</h3>
            <div className="text-sm text-gray-400 space-y-3">
              <div>
                <p className="font-semibold text-white">Baar (Hauptsitz)</p>
                <p>Bahnhofstrasse 8B<br />6340 Baar</p>
              </div>
              <div>
                <p className="font-semibold text-white">Ebikon</p>
                <p>Dorfstrasse 5<br />6030 Ebikon</p>
              </div>
              <div>
                <p className="font-semibold text-white">Kriens</p>
                <p>Sportweg 5<br />6010 Kriens</p>
              </div>
            </div>
          </div>
          
          <div>
            <h3 className="font-heading font-bold text-lg mb-4">Rechtliches</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="text-gray-400 hover:text-gold transition-colors">
                  Kurz-AGB
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-gold transition-colors">
                  Vollständige AGB
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-gold transition-colors">
                  Datenschutz
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-gold transition-colors">
                  Impressum
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-heading font-bold text-lg mb-4">Kontakt</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Tel: 041 440 22 23</li>
              <li>WhatsApp: +41 79 708 50 08</li>
              <li>info@dasgroup.ch</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8 text-center">
          <a 
            href="https://dasgroup.ch" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block bg-gold hover:bg-gold-hover text-white font-semibold px-6 py-3 rounded-lg transition-colors duration-200 mb-6"
          >
            Zurück zur Hauptseite
          </a>
          <p className="text-sm text-gray-400 mb-2">
            DAS Group Autovermietung - Teil der <a href="https://dasgroup.ch" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-gold-hover transition-colors">DAS Group AG</a>
          </p>
          <p className="text-sm text-gray-400">&copy; {new Date().getFullYear()} DAS Group AG. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
};
